<template>
  <div>
    <v-snackbar v-model="snackbar" color="success" top>
      {{ "alerts_business_updated" | localize }}
    </v-snackbar>
    <VRow
      class="mt-12 mb-3 mx-1"
      v-if="!editBusiness && $vuetify.breakpoint.smAndDown"
    >
      <v-progress-linear
        height="17"
        style="border-radius: 20px"
        color="#73AFE7"
        value="25"
      ></v-progress-linear>
    </VRow>
    <v-card-title class="mt-2 pl-1 pa-0" v-if="!editBusiness">
      <VRow
        no-gutters
        :class="
          $vuetify.breakpoint.smAndDown ? 'font-weight-bold my-2' : 'mt-8'
        "
        justify="center"
        justify-sm="start"
        >{{ "add_business_second_step_subtitle" | localize }}</VRow
      >
    </v-card-title>
    <VRow no-gutters>
      <v-col class="col-12 col-lg-2 mr-lg-5" v-if="editBusiness">
        <v-btn
          elevation="1"
          class="img-btn mx-auto"
          color="white"
          @click="toggleShow"
          tile
          v-if="!imgDataUrl"
          id="logo_upload"
          :disabled="
            loggedUser.role_id === '0' ||
            loggedUser.role_id === '1' ||
            loggedUser.role_id === '4'
              ? false
              : true
          "
        >
          <div class="align-center">
            <div>
              <VIcon color="#72afe7 " large>mdi-camera</VIcon>
            </div>
            <div class="text-sm mt-3">
              <span>{{ "add_business_second_step_logo" | localize }}</span>
            </div>
          </div>
        </v-btn>
        <v-btn
          elevation="1"
          class="img-btn mx-auto"
          color="white"
          @click="toggleShow"
          tile
          v-if="!editBusiness.shop_logo && imgDataUrl && !socials"
        >
          <img class="ins-img" :src="imgDataUrl" />
        </v-btn>
        <v-btn
          elevation="1"
          class="img-btn mx-auto"
          color="white"
          @click="toggleShow"
          tile
          v-if="!editBusiness.shop_logo && imgDataUrl && socials"
        >
          <img class="ins-img" :src="imgDataUrl" />
        </v-btn>
        <v-btn
          elevation="1"
          class="img-btn mx-auto"
          color="white"
          @click="toggleShow"
          tile
          v-if="
            (editBusiness.shop_logo || editBusiness.logo) &&
            imgDataUrl &&
            !socials
          "
        >
          <img class="ins-img" v-if="!socials" :src="editBusiness.shop_logo" />
        </v-btn>
      </v-col>
      <my-upload
        field="img"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="show"
        :width="512"
        :height="512"
        :params="params"
        :lang-type="loggedUser.locale === 'es' ? 'es-MX' : 'en'"
        noCircle
        :headers="headers"
        img-format="png"
      ></my-upload>
      <v-col>
        <v-card-text class="mt-3">
          <VRow>
            <v-col class="col-12" v-if="editBusiness && !socials">
              <v-text-field
                style="width: 30%"
                v-model="editBusiness.referral_id"
                dense
                outlined
                disabled
                :label="'description_business_id' | localize"
              >
              </v-text-field>
            </v-col>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-text-field
                v-if="!socials"
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                :class="
                  !nameError.length && !nameMessages.length
                    ? 'mb-5 mr-sm-2 name'
                    : 'mr-sm-2 name'
                "
                v-model="business.name"
                dense
                outlined
                @input="nameMessages = []"
                :hide-details="!nameError.length && !nameMessages.length"
                :error-messages="
                  nameMessages.length > 0 ? nameMessages : nameError | localize
                "
              >
                <template v-slot:label
                  >{{
                    "add_business_second_step_label_business_title" | localize
                  }}
                  <span class="req">*</span></template
                >
              </v-text-field>
              <v-text-field
                v-else
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                :class="
                  !nameError.length && !nameMessages.length
                    ? 'mb-5 mr-sm-2 name'
                    : 'mr-sm-2 name'
                "
                v-model="business.name"
                dense
                outlined
                @input="nameMessages = []"
                :hide-details="!nameError.length && !nameMessages.length"
                :error-messages="
                  nameMessages.length > 0 ? nameMessages : nameError | localize
                "
              >
                <template v-slot:label
                  >{{
                    "add_socials_second_step_label_business_title" | localize
                  }}
                  <span class="req">*</span></template
                >
              </v-text-field>
            </v-col>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <!-- types of business -->

              <!-- <div
                :class="!typeError.length ? 'type mb-5' : 'type'"
                v-if="!socials"
              >
                <v-autocomplete
                  :disabled="
                    loggedUser.role_id === '0' ||
                    loggedUser.role_id === '1' ||
                    loggedUser.role_id === '4'
                      ? false
                      : true
                  "
                  dense
                  outlined
                  class="type"
                  v-model="business.type"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="Object.values(businessTypes)"
                  :item-value="'type_id'"
                  :item-text="'name'"
                  chips
                  :error-messages="typeError | localize"
                  :hide-details="!typeError.length"
                  ><template class="type" #selection="{ item }">
                    <v-chip
                      small
                      dark
                      :color="
                        loggedUser.role_id === '0' ||
                        loggedUser.role_id === '1' ||
                        loggedUser.role_id === '4'
                          ? '#72AFE7'
                          : 'rgb(218, 218, 218)'
                      "
                      >{{ item.name }}</v-chip
                    >
                  </template>
                  <template class="type" v-slot:label
                    >{{
                      "add_business_second_step_select_type" | localize
                    }}*</template
                  >
                </v-autocomplete>
              </div> -->
              <div
                :class="!typeError.length ? 'type mb-5' : 'type'"
                v-if="socials"
              >
                <v-autocomplete
                  :disabled="
                    loggedUser.role_id === '0' ||
                    loggedUser.role_id === '1' ||
                    loggedUser.role_id === '4'
                      ? false
                      : true
                  "
                  dense
                  outlined
                  class="type"
                  v-model="business.type"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="Object.values(businessTypes)"
                  :item-value="'id'"
                  :item-text="'name'"
                  :error-messages="typeError | localize"
                  :hide-details="!typeError.length"
                >
                  <template v-slot:label
                    >{{ "add_socials_second_step_select_type" | localize }}
                    <span class="req">*</span></template
                  >
                </v-autocomplete>
              </div>
            </v-col>
          </VRow>
          <VRow v-if="!socials">
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-autocomplete
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                :class="
                  !categoryError.length
                    ? 'mb-5 mr-sm-2 category'
                    : 'mr-sm-2 category'
                "
                v-model="business.category"
                :menu-props="{ bottom: true, offsetY: true }"
                :items="Object.values(categories)"
                :item-value="'id'"
                :item-text="'name'"
                :error-messages="categoryError | localize"
                :hide-details="!categoryError.length"
              >
                <template v-slot:label
                  >{{ "list_event_category" | localize }}
                  <span class="req">*</span></template
                ></v-autocomplete
              >
            </v-col>
            <v-col
              :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'"
              v-if="subcategories.length > 0 && !socials"
            >
              <v-autocomplete
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                multiple
                class="mb-5 mr-sm-2 subcategory"
                v-model="business.subcategories"
                hide-details
                :menu-props="{ bottom: true, offsetY: true }"
                :items="Object.values(subcategories)"
                :item-value="'id'"
                :item-text="'name'"
              >
                <template v-slot:label
                  >Subcategory <span class="req">*</span></template
                ></v-autocomplete
              >
            </v-col>
          </VRow>
          <VRow class="mb-5">
            <v-textarea
              v-if="!socials"
              :disabled="
                loggedUser.role_id === '0' ||
                loggedUser.role_id === '1' ||
                loggedUser.role_id === '4'
                  ? false
                  : true
              "
              class="description"
              dense
              rows="2"
              v-model="business.description"
              outlined
              hide-details
              :label="
                'add_business_second_step_placeholder_description' | localize
              "
            >
            </v-textarea>
            <v-textarea
              v-else
              :disabled="
                loggedUser.role_id === '0' ||
                loggedUser.role_id === '1' ||
                loggedUser.role_id === '4'
                  ? false
                  : true
              "
              dense
              rows="2"
              v-model="business.description"
              outlined
              hide-details
              label="
                Desription
              "
            >
            </v-textarea>
          </VRow>
          <VRow :class="!emailError.length ? 'mb-5' : ''">
            <v-text-field
              :disabled="
                loggedUser.role_id === '0' ||
                loggedUser.role_id === '1' ||
                loggedUser.role_id === '4'
                  ? false
                  : true
              "
              class="email"
              dense
              v-model="business.email"
              outlined
              :error-messages="emailError | localize"
              :hide-details="!emailError.length"
            >
              <template v-slot:label
                >{{ "label_login_email" | localize }}
                <span class="req">*</span></template
              >
            </v-text-field>
          </VRow>
          <VRow class="phone" :class="!phoneNumberError.length ? 'mb-5' : ''">
            <v-col
              cols="3"
              class="col-md-3 col-xs-12 col-sm-12 mr-md-2 mb-sm-5 mb-xs-5 mb-md-0"
            >
              <v-text-field
                dense
                outlined
                label="Phone code *"
                v-model="business.phoneCode"
                @keypress="isNumber($event)"
                return-masked-value
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                :maxLength="
                  business.phoneNumber && business.phoneNumber.length > 12
                    ? 15 - business.phoneNumber.length
                    : 4
                "
                v-mask="'####'"
                prefix="+"
                :hide-details="!phoneCodeError.length"
                :error-messages="phoneCodeError | localize"
              >
                <template v-slot:label
                  >{{ "phone_code_label" | localize }}
                  <span class="req">*</span></template
                >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                v-model="business.phoneNumber"
                @keypress="isNumber($event)"
                :class="
                  $vuetify.breakpoint.xs
                    ? 'ml-2'
                    : 'mb-xs-5 mb-sm-5 mb-md-0 ml-1'
                "
                return-masked-value
                :maxLength="15 - business.phoneCode.length"
                :error-messages="phoneNumberError | localize"
                :hide-details="!phoneNumberError.length"
              >
                <template v-slot:label
                  >{{ "add_business_second_step_label_phone" | localize }}
                  <span class="req">*</span></template
                >
              </v-text-field>
            </v-col>
            <!-- <v-col
              no-gutters
              cols="12"
              class="col-md-3 col-xs-12 col-sm-12 ml-md-2"
            >
              <v-text-field
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                label="Ext"
                maxlength="6"
                return-masked-value
                v-mask="'######'"
                v-model="business.phoneExt"
                hide-details
              >
              </v-text-field>
            </v-col> -->
          </VRow>
          <VRow>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-autocomplete
                dense
                outlined
                autocomplete="new-password"
                :error-messages="municipalityError"
                class="mb-5 mr-sm-2 municipality"
                :hide-details="!municipalityError.length"
                v-model="business.municipality"
                :menu-props="{ bottom: true, offsetY: true }"
                :items="municipalities"
                :item-value="'id'"
                :item-text="'name'"
              >
                <template v-slot:label
                  >{{ "municipality_placeholder" | localize }}
                  <span class="req">*</span>
                </template></v-autocomplete
              >
            </v-col>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-autocomplete
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                :class="'neighbourhood mb-5'"
                v-model="business.neighbourhood"
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details
                :items="Object.values(neighbourhoods)"
                :item-value="'id'"
                :item-text="'name'"
              >
                <template v-slot:label
                  >{{ "label_login_neighbourhood" | localize }}
                </template></v-autocomplete
              >
            </v-col>
          </VRow>
          <VRow>
            <v-col class="col-12">
              <v-text-field
                class="website mb-5"
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                v-model="business.website"
                outlined
                hide-details
                :label="'add_business_second_step_label_website' | localize"
              >
              </v-text-field>
            </v-col>
          </VRow>
          <VRow>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-select
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                class="mr-sm-2 mb-5 internetAccess"
                dense
                outlined
                :menu-props="{ bottom: true, offsetY: true }"
                :items="Object.values(businessInternet)"
                :item-value="'value'"
                :item-text="'text'"
                v-model="business.internetAccess"
                hide-details
              >
                <template v-slot:label>{{
                  "label_login_internet" | localize
                }}</template>
              </v-select>
            </v-col>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-select
                v-if="!socials"
                class="mb-5 cashiersDevice"
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                v-model="business.cashiersDevice"
                :items="Object.values(devices)"
                :item-value="'id'"
                :item-text="'name'"
                :menu-props="{ bottom: true, offsetY: true }"
                label="Cashier's device?"
                hide-details
              >
                <template v-slot:label>{{
                  "label_login_device_access" | localize
                }}</template></v-select
              >
            </v-col>
          </VRow>
          <VRow>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-select
                v-if="!socials"
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                class="employees mb-5 mr-sm-2"
                outlined
                v-model="business.employees"
                :items="Object.values(sizes)"
                :item-value="'id'"
                :item-text="'name'"
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details
              >
                <template v-slot:label>{{
                  "label_login_size" | localize
                }}</template></v-select
              >
              <v-select
                v-if="socials"
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                class="employees mb-5 mr-sm-2"
                outlined
                v-model="business.employees"
                :items="Object.values(sizes)"
                :item-value="'id'"
                :item-text="'name'"
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details
              >
                <template v-slot:label>{{
                  "label_login_size" | localize
                }}</template></v-select
              >
            </v-col>
            <v-col :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'">
              <v-select
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                class="status mb-5"
                v-model="business.status"
                :items="Object.values(businessStatusItems)"
                :item-value="'value'"
                :item-text="'text'"
                :menu-props="{ bottom: true, offsetY: true }"
                label="Status *"
                :error-messages="statusError | localize"
                hide-details
              >
                <template v-slot:label
                  >{{ "add_business_second_step_label_status" | localize }}
                  <span class="req">*</span></template
                ></v-select
              >
            </v-col>
          </VRow>
          <VRow v-if="!socials">
            <v-col
              :class="
                $vuetify.breakpoint.xs || editBusiness ? 'col-12' : 'col-6'
              "
            >
              <v-text-field
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                :class="
                  editBusiness ? `mb-5 chambers` : `mb-5 mr-sm-2 chambers`
                "
                dense
                outlined
                @keypress="isNumber($event)"
                v-model="business.chambers"
                :maxLength="12"
                hide-details
                :label="'add_business_canaco_id' | localize"
              >
              </v-text-field>
            </v-col>
            <v-col
              :class="$vuetify.breakpoint.xs ? 'col-12' : 'col-6'"
              v-if="!editBusiness"
            >
              <v-text-field
                :class="!refMessages.length ? 'ref mb-5' : 'ref'"
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                v-model="business.ref"
                :error-messages="refMessages | localize"
                :hide-details="!refMessages.length"
                :label="'label_referral_business_id' | localize"
              >
              </v-text-field>
            </v-col>
          </VRow>
          <VRow v-else>
            <v-col
              :class="
                $vuetify.breakpoint.xs || editBusiness ? 'col-12' : 'col-6'
              "
            >
              <v-select
                :disabled="
                  loggedUser.role_id === '0' ||
                  loggedUser.role_id === '1' ||
                  loggedUser.role_id === '4'
                    ? false
                    : true
                "
                dense
                outlined
                class="status mb-5"
                v-model="business.label"
                :items="Object.values(socialLabels)"
                :item-value="'value'"
                :item-text="'text'"
                :menu-props="{ bottom: true, offsetY: true }"
                label="*Label is public* *"
                :error-messages="statusError | localize"
                hide-details
              >
                <template v-slot:label
                  >{{ "label_is_public" | localize }}
                  <span class="req">*</span></template
                ></v-select
              >
            </v-col>
          </VRow>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto mx-sm-0 ml-sm-auto">
            <v-btn
              v-on:click="checkName()"
              block
              class="white--text next px-15 px-sm-5"
              color="#72AFE7"
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'text-transform: none; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);'
                  : ''
              "
              v-if="!editBusiness"
              >{{ "add_business_next" | localize }}</v-btn
            >
            <v-btn
              v-on:click="checkName()"
              block
              :loading="updateLoading"
              class="white--text"
              color="#72AFE7"
              v-if="
                (!$vuetify.breakpoint.xs &&
                  editBusiness &&
                  loggedUser.role_id === '0') ||
                (!$vuetify.breakpoint.xs &&
                  editBusiness &&
                  loggedUser.role_id === '1') ||
                (!$vuetify.breakpoint.xs &&
                  editBusiness &&
                  loggedUser.role_id === '4')
              "
              >{{ "add_business_update" | localize }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-col>
    </VRow>
  </div>
</template>

<script>
import BusinessService from "@/requests/Business/BusinessService";
import ProfileService from "@/requests/Profile/ProfileService";
import SocialService from "@/requests/Socials/SocialService";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import ListService from "@/requests/List/ListService";
import myUpload from "vue-image-crop-upload/upload-2.vue";
//const validPhone = (value) => value.replace(/[^+\d]/g, "").length === 10;
//const validCode = (value) => value.replace(/[^+\d]/g, "").length <= 5;
import Shepherd from "shepherd.js";
import requestFormData from "@/requests/requestFormData";
import en from "@/locales/en.json";
import es from "@/locales/es.json";

const tour = new Shepherd.Tour({
  defaultStepOptions: {
    scrollTo: true,
    cancelIcon: { enabled: true },
    popperOptions: {
      modifiers: [{ name: "focusAfterRender", enabled: true }],
    },
  },
  useModalOverlay: true,
});

tour.on("cancel", () => {
  localStorage.tutorialStep = tour.getCurrentStep().id;
});

export default {
  components: {
    "my-upload": myUpload,
  },
  mixins: [validationMixin],
  props: {
    editBusiness: {
      type: Object,
      require: false,
    },
    updates: {
      require: false,
    },
  },
  data: () => ({
    businessTypes: [],
    neighbourhoods: [],
    devices: [],
    socials: false,
    business: {
      phoneCode: "",
      municipality: "1",
      neighbourhood: "",
    },
    businessStatusItems: [],
    socialLabels: [],
    businessInternet: [],
    nameMessages: [],
    categories: [],
    subcategories: [],
    municipalities: [],
    lang: null,
    refMessages: [],
    sizes: [],
    checkShowUpload: false,
    oldImgUrl: "",
    imgDataUrl: "",
    snackbar: false,
    show: false,
    params: {
      token: "123456798",
      name: "avatar",
    },
    updateLoading: false,
    headers: {
      smail: "*_~",
    },
  }),
  validations() {
    return {
      business: {
        name: {
          required,
        },
        type: {
          required,
        },
        category: {
          required,
        },
        phoneCode: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(4),
        },
        phoneNumber: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(15 - this.business.phoneCode.length),
        },
        email: {
          required,
          email,
        },
        municipality: {
          required,
        },
        status: {
          required,
        },
      },
    };
  },
  beforeDestroy() {
    this.resetSteps();
  },
  // destroyed() {
  //   this.resetSteps();
  // },
  mounted() {
    if (process.env.VUE_APP_TYPE === "Social") {
      this.socials = true;
      this.getLabel();

      if (!this.editBusiness) {
        this.getProfile();
      }
    }
    this.updateStepsText();
    this.business.phoneCode = "52";
    this.translateStatus();
    this.getBusinessTypes();
    this.getCategories();
    this.getNeighbourhoods();
    this.getMunicipalities();
    this.getDevices();
    this.getBusinessSizes();
    if (this.editBusiness) {
      this.getBusinessEdit();
    }
    if (localStorage.tutorialStep == "add") {
      this.startTutorial();
    }
  },
  watch: {
    updates: {
      deep: true,
      handler() {
        if (this.socials) {
          this.updateSocial();
        } else {
          this.update();
        }
      },
    },
    imgDataUrl: {
      handler() {
        if (this.editBusiness && this.$vuetify.breakpoint.smAndDown) {
          let business = {
            shop_logo: this.imgDataUrl,
          };
          this.$emit("changed_business", business);
        }
      },
    },
    business: {
      deep: true,
      handler() {
        if (this.editBusiness && this.$vuetify.breakpoint.smAndDown) {
          let business = {
            shop_name: this.business.name,
            shop_logo: this.imgDataUrl,
            shop_description: this.business.description,
            shop_email: this.business.email,
            phone_number: this.business.phoneNumber,
            phone_code: this.business.phoneCode,
            shop_website: this.business.website,
            canaco_id: this.business.chambers,
            internet: this.business.internetAccess,
            status: this.business.status,
            neighbourhood: this.business.neighbourhood,
            device_access: this.business.cashiersDevice,
            size: this.business.employees,
          };
          business.category = this.business.category;
          business.subcategories = this.business.subcategories;
          this.$emit("changed_business", business);
        }
      },
    },
    loggedUser: function (newUser) {
      this.loggedUser = newUser;
      this.updateStepsText();
      this.translateStatus();
      this.getNeighbourhoods();
      this.getBusinessTypes();
      this.getCategories();
      this.getSubcategories();
      this.getDevices();
      this.getLabel();
    },
    "business.name": function (name) {
      if (tour.isActive()) {
        let step = tour.getById("name");
        if (name) {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action() {
                  return this.show("upload-logo");
                },
                classes: "shepferd-theme-prev-btn",
              },
              {
                text: this.lang["tour-next-step"],
                action: tour.next,
                classes: "shepferd-theme-next-btn",
              },
            ],
          });
        } else {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action() {
                  return this.show("upload-logo");
                },
                classes: "shepferd-theme-prev-btn",
              },
            ],
          });
        }
      }
    },
    "business.email": function (email) {
      if (tour.isActive()) {
        let step = tour.getById("email");
        this.$set(this.business, "email", email);
        this.$v.business.email.$touch();
        if (!this.emailError.length) {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
              {
                text: this.lang["tour-next-step"],
                action: tour.next,
                classes: "shepferd-theme-next-btn",
              },
            ],
          });
        } else {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
            ],
          });
        }
      }
    },
    "business.type": function (type) {
      if (tour.isActive()) {
        let step = tour.getById("type");
        if (type) {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
              {
                text: this.lang["tour-next-step"],
                action: tour.next,
                classes: "shepferd-theme-next-btn",
              },
            ],
          });
        } else {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
            ],
          });
        }
      }
    },
    "business.category": function (category) {
      if (!this.socials && category) {
        ListService.getBusinessSubcategories(category).then((response) => {
          this.subcategories = response.result;

          if (tour.isActive()) {
            let step = tour.getById("category");
            let stepSub = tour.getById("subcategory");

            if (category) {
              let buttons = [];
              buttons.push({
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              });
              stepSub.updateStepOptions({
                showOn: function () {
                  return this.subcategories && this.subcategories.length
                    ? true
                    : false;
                },
              });
              if (this.subcategories.length) {
                buttons.push({
                  text: this.lang["tour-next-step"],
                  action: tour.next,
                  classes: "shepferd-theme-next-btn",
                });

                // stepDesc.updateStepOptions({
                //   buttons: [
                //     {
                //       text: this.lang["tour-previous-step"],
                //       action: tour.back,
                //       classes: "shepferd-theme-prev-btn",
                //     },
                //     {
                //       text: this.lang["tour-next-step"],
                //       action: tour.next,
                //       classes: "shepferd-theme-next-btn",
                //     },
                //   ],
                // });
              } else {
                buttons.push({
                  text: this.lang["tour-next-step"],
                  action: tour.next,
                  classes: "shepferd-theme-next-btn",
                });

                // stepDesc.updateStepOptions({
                //   buttons: [
                //     {
                //       text: this.lang["tour-previous-step"],
                //       action: tour.next("category"),
                //       classes: "shepferd-theme-prev-btn",
                //     },
                //     {
                //       text: this.lang["tour-next-step"],
                //       action: tour.next,
                //       classes: "shepferd-theme-next-btn",
                //     },
                //   ],
                // });
              }
              step.updateStepOptions({
                buttons: buttons,
              });
            } else {
              step.updateStepOptions({
                buttons: [
                  {
                    text: this.lang["tour-previous-step"],
                    action: tour.back,
                    classes: "shepferd-theme-prev-btn",
                  },
                ],
              });
            }
          }
        });
      }
    },
    "business.subcategories": function (subcategories) {
      if (tour.isActive()) {
        let step = tour.getById("subcategory");
        if (subcategories) {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
              {
                text: this.lang["tour-next-step"],
                action: tour.next,
                classes: "shepferd-theme-next-btn",
              },
            ],
          });
        } else {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
            ],
          });
        }
      }
    },
    "business.phoneNumber": function (number) {
      if (tour.isActive()) {
        let step = tour.getById("phone");
        this.$set(this.business, "phoneNumber", number);
        this.$v.business.phoneNumber.$touch();
        if (!this.phoneNumberError.length) {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
              {
                text: this.lang["tour-next-step"],
                action: tour.next,
                classes: "shepferd-theme-next-btn",
              },
            ],
          });
        } else {
          step.updateStepOptions({
            buttons: [
              {
                text: this.lang["tour-previous-step"],
                action: tour.back,
                classes: "shepferd-theme-prev-btn",
              },
            ],
          });
        }
      }
    },
    // "business.municipality": function (municipality) {
    //   if (tour.isActive()) {
    //     let step = tour.getById("municipality");
    //     if (municipality) {
    //       step.updateStepOptions({
    //         buttons: [
    //           {
    //             text: this.lang["tour-previous-step"],
    //             action: tour.back,
    //             classes: "shepferd-theme-prev-btn",
    //           },
    //           {
    //             text: this.lang["tour-next-step"],
    //             action: tour.next,
    //             classes: "shepferd-theme-next-btn",
    //           },
    //         ],
    //       });
    //     } else {
    //       step.updateStepOptions({
    //         buttons: [
    //           {
    //             text: this.lang["tour-previous-step"],
    //             action: tour.back,
    //             classes: "shepferd-theme-prev-btn",
    //           },
    //         ],
    //       });
    //     }
    //   }
    // },
  },
  methods: {
    updateStepsText() {
      if (this.loggedUser.locale === "en") {
        this.lang = en;
      } else {
        this.lang = es;
      }
      this.resetSteps();
    },
    resetSteps() {
      //localStorage.tutorialStep = "";
      tour.complete();
      tour.removeStep("upload-logo");
      tour.removeStep("upload");
      tour.removeStep("crop");
      tour.removeStep("save");
      tour.removeStep("name");
      //tour.removeStep("type");
      tour.removeStep("category");
      tour.removeStep("subcategory");
      tour.removeStep("description");
      tour.removeStep("email");
      tour.removeStep("phone");
      tour.removeStep("website");
      tour.removeStep("neighbourhood");
      tour.removeStep("municipality");
      tour.removeStep("internetAccess");
      tour.removeStep("chambers");
      tour.removeStep("cashiersDevice");
      tour.removeStep("employees");
      tour.removeStep("status");
      tour.removeStep("next");
      tour.removeStep("ref");
    },
    getLabel() {
      if (this.loggedUser.locale === "en") {
        this.socialLabels.push(
          { text: "Public", value: "Yes" },
          { text: "Private", value: "No" }
        );
      } else {
        this.socialLabels.push(
          { text: "Pública", value: "Yes" },
          { text: "Privado", value: "No" }
        );
      }
      this.business.label = this.socialLabels[0];
    },
    translateStatus() {
      this.businessStatusItems = [];
      if (this.loggedUser.locale === "en") {
        this.businessStatusItems.push({ text: "Active", value: "Active" });
        this.businessStatusItems.push({ text: "InActive", value: "InActive" });
      } else {
        this.businessStatusItems.push({ text: "Activo", value: "Active" });
        this.businessStatusItems.push({ text: "InActivo", value: "InActive" });
      }
      if (this.loggedUser.locale === "en") {
        this.businessInternet.push({ text: "Yes", value: "Yes" });
        this.businessInternet.push({ text: "No", value: "No" });
      } else {
        this.businessInternet.push({ text: "Si", value: "Yes" });
        this.businessInternet.push({ text: "No", value: "No" });
      }
    },
    onUploadClick(show) {
      this.checkShowUpload = show;
      if (tour.isActive() && this.checkShowUpload) {
        tour.show("upload");
      }
    },
    isNumber(evt) {
      const isNumber = isFinite(evt.key);
      if (!isNumber) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.editBusiness.shop_logo = "";
      this.imgDataUrl = imgDataUrl;
      console.log("field: " + field);
    },
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    checkName() {
      if (this.socials) {
        this.$set(this.business, "cashiersDevice", 44);
        this.$set(this.business, "category", 44);
        this.$set(this.business, "subcategories", ["1", "2"]);
      } else {
        this.$set(this.business, "type", 1);
      }
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let form = new FormData();
          console.log("social1");
          if (this.socials) {
            form.append("name", this.business.name);
            console.log("social");
            SocialService.checkName(form).then((res) => {
              console.log("social", res);
              if (res.result.count === 0) {
                if (this.editBusiness) {
                  this.updateSocial();
                } else {
                  this.next();
                }
              }
            });
          } else {
            this.updateLoading = true;
            form.append("shop_name", this.business.name);
            BusinessService.checkName(form).then((res) => {
              console.log("edit business", res);
              if (
                res.result.count === 0 ||
                (this.editBusiness &&
                  this.business.name.toLowerCase() ===
                    this.editBusiness.shop_name.toLowerCase())
              ) {
                if (this.editBusiness) {
                  this.update();
                  console.log("tut");
                } else {
                  this.next();
                }
              } else {
                this.updateLoading = false;
                tour.show("name");
                this.nameMessages.push("validation_business_name_unique");
                window.scrollTo({
                  top: 200,
                  behavior: "smooth",
                });
              }
            });
          }
        } else {
          window.scrollTo({
            top: 200,
            behavior: "smooth",
          });
        }
      } catch (e) {
        this.showLoader = false;
      }
    },
    next() {
      let check = tour.isActive();
      console.log(check);
      console.log(this.business.subcategories);
      this.$v.$touch();
      this.nameMessages = [];
      this.refMessages = [];
      if (!this.$v.$invalid) {
        if (
          typeof this.business.ref !== "undefined" &&
          this.business.ref !== ""
        ) {
          let form_ref = new FormData();
          form_ref.append("referral_id", this.business.ref);
          BusinessService.checkRefferal(form_ref).then((res) => {
            if (res) {
              this.$emit("addedInfo", this.business, check);
            } else if (!res) {
              this.refMessages.push("validation_referral_id_incorrect");
            }
          });
        } else {
          this.$emit("addedInfo", this.business, check);
          tour.complete();
        }
      }
    },
    updateSocial() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          var form = new FormData();
          form.append("type", parseInt(this.business.type));
          form.append("name", this.business.name);
          form.append("description", this.business.description || "");
          form.append("email", this.business.email);
          form.append("is_public", this.business.label);
          form.append(
            "phone_code",
            this.business.phoneCode.replace(/\D+/g, "")
          );
          form.append(
            "phone_number",
            this.business.phoneNumber.replace(/\D+/g, "")
          );
          form.append("website", this.business.website || "");
          form.append("address", this.editBusiness.address || "");
          form.append("geo_lat", parseFloat(this.editBusiness.geo_lat));
          form.append("geo_lon", parseFloat(this.editBusiness.geo_lon));
          form.append("neighbourhood", parseInt(this.business.neighbourhood));
          form.append("internet", this.business.internetAccess);
          form.append("status", this.business.status);
          form.append("size", this.business.employees);
          if (this.oldImgUrl != this.imgDataUrl) {
            form.append("logo", this.imgDataUrl);
          }
          form.append("working_days", this.editBusiness.working_days);
          form.append("working_hours", this.editBusiness.working_hours);
          var object = {};
          form.forEach(function (value, key) {
            object[key] = value;
          });
          object["working_days"] = this.editBusiness.working_days;
          object["working_hours"] = this.editBusiness.working_hours;

          let formParsed = requestFormData.jsonToFormData(object);
          SocialService.updateSocial(this.$route.params.sid, formParsed).then(
            (res) => {
              this.$emit("changedInfo", res.result);
              this.snackbar = true;
            }
          );
        } catch (e) {
          this.showLoader = false;
        }
      }
    },
    update() {
      this.$v.$touch();
      console.log(this.$v.$invalid);
      if (!this.$v.$invalid) {
        try {
          this.updateLoading = true;
          let categories;
          let category_array = [];
          if (
            this.business.subcategories &&
            this.business.subcategories.length > 0
          ) {
            categories = this.business.subcategories.map((i) => Number(i));
            for (let i = 0; i < categories.length; i++) {
              category_array.push({
                category_id: parseInt(this.business.category),
                subcategory_id: categories[i],
              });
            }
          } else {
            category_array.push({
              category_id: parseInt(this.business.category),
            });
          }
          var form = new FormData();
          //form.append("type", parseInt(this.business.type));
          form.append("shop_name", this.business.name);
          form.append("shop_description", this.business.description || "");
          form.append("shop_email", this.business.email);
          form.append(
            "phone_code",
            this.business.phoneCode.replace(/\D+/g, "")
          );
          form.append("phone_number", this.business.phoneNumber);
          form.append("shop_website", this.business.website || "");
          form.append("address", this.editBusiness.address || "");
          form.append("geo_lat", parseFloat(this.editBusiness.geo_lat));
          form.append("geo_lon", parseFloat(this.editBusiness.geo_lon));
          form.append("neighbourhood", parseInt(this.business.neighbourhood));
          form.append("device_access", this.business.cashiersDevice);
          form.append("internet", this.business.internetAccess);
          form.append("status", this.business.status);
          form.append("size", this.business.employees);
          form.append("canaco_id", this.business.chambers);
          form.append("municipality", this.business.municipality);
          form.append("shop_logo", this.imgDataUrl);
          form.append("city_id", this.editBusiness.city_id);
          form.append(
            "discount_amount_min",
            parseInt(this.editBusiness.discount_amount_min) || 5
          );
          form.append(
            "discount_amount_max",
            parseInt(this.editBusiness.discount_amount_max) || 5
          );
          form.append("discount_type", this.editBusiness.discount_type) ||
            "All";
          form.append("working_days", this.editBusiness.shop_working_days);
          form.append("working_hours", this.editBusiness.working_hours);
          var object = {};
          form.forEach(function (value, key) {
            object[key] = value;
          });
          object["working_days"] = this.editBusiness.shop_working_days;
          object["working_hours"] = this.editBusiness.working_hours;
          object["category"] = category_array;

          let formParsed = requestFormData.jsonToFormData(object);
          BusinessService.updateBusiness(
            this.$route.params.bid,
            formParsed
          ).then((res) => {
            this.$emit("changedInfo", res.result);
            this.snackbar = true;
          });
        } catch (e) {
          this.showLoader = false;
        } finally {
          this.updateLoading = false;
        }
      }
    },
    async getBusinessTypes() {
      try {
        let response = null;
        if (this.socials) {
          response = await ListService.getSocialTypes();
        } else {
          response = await ListService.getBusinessTypes();
        }
        this.businessTypes = response.result;
      } catch (e) {
        this.showLoader = false;
      }
    },
    async getCategories() {
      if (!this.socials) {
        let response = await ListService.getBusinessCategories();
        this.categories = response.result;
      }
    },
    async getSubcategories(category) {
      if (!this.socials && category) {
        let response = await ListService.getBusinessSubcategories(category);
        this.subcategories = response.result;
      }
    },
    async getNeighbourhoods() {
      try {
        var response = await ListService.getNeighbourhood();
        this.neighbourhoods = response.result;
      } catch (e) {
        this.showLoader = false;
      }
    },
    async getMunicipalities() {
      try {
        var response = await ListService.getMunicipalities();
        this.municipalities = response.result;
      } catch (e) {
        this.showLoader = false;
      }
    },
    async getDevices() {
      var response = await ListService.getDevices();
      this.devices = response.result;
      if (!this.editBusiness) {
        this.business.cashiersDevice = "";
        this.business.internetAccess = "";
      } else {
        for (let i = 0; i < this.devices.length; i++) {
          if (this.devices[i].id == this.editBusiness.device_access) {
            this.business.cashiersDevice = this.devices[i].id;
          }
        }
        this.business.internetAccess = this.editBusiness.internet;
      }
    },
    async getBusinessSizes() {
      var response = await ListService.getBusinessSizes();
      this.sizes = response.result;
      if (!this.editBusiness) {
        if (this.socials) {
          this.business.employees = "";
        } else {
          this.business.employees = "";
        }
        this.business.status = "Active";
      } else {
        for (let i = 0; i < this.sizes.length; i++) {
          if (this.sizes[i].id == this.editBusiness.size) {
            this.business.employees = this.sizes[i].id;
          }
        }
        if (this.editBusiness.status == "InActive") {
          this.business.status = "InActive";
        } else {
          this.business.status = this.editBusiness.status;
        }
      }
    },
    checkShow() {
      tour.hide();
      //tour.show('name')
    },
    getProfile() {
      ProfileService.getProfile().then((res) => {
        this.$set(this.business, "phoneNumber", res.result.phone_number);
        this.$set(this.business, "name", res.result.company_name);
        this.$set(this.business, "email", res.result.email);
      });
    },
    onSaveImage() {
      if (tour.isActive()) {
        tour.show("name");
      }
    },
    onUploadImage() {
      if (tour.isActive()) {
        setTimeout(function () {
          tour.show("crop");
        }, 1000);
      }
    },
    toUpload() {
      if (tour.isActive()) {
        setTimeout(function () {
          tour.show("upload");
        }, 500);
      }
    },
    getLast() {
      setTimeout(function () {
        tour.start();
        tour.show("next");
      }, 500);
    },
    startTutorial() {
      let that = this;
      if (!tour.getById("upload-logo")) {
        tour.addStep({
          id: "upload-logo",
          text: that.lang["tour-create-business-upload-logo"],
          attachTo: {
            element: ".img-btn",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-next-step"],
              action() {
                return this.show("name");
              },
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("upload")) {
        tour.addStep({
          id: "upload",
          text: that.lang["tour-create-business-upload-logo-browse"],
          attachTo: {
            element: ".vicp-step1",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action() {
                that.$emit("toggleShow");
                return this.show("upload-logo");
              },
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      if (!tour.getById("crop")) {
        tour.addStep({
          id: "crop",
          text: that.lang["tour-create-business-upload-logo-crop"],
          attachTo: {
            element: ".vicp-crop-left",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action() {
                that.$emit("toFirstStep");
                that.toUpload();
              },
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("save")) {
        tour.addStep({
          id: "save",
          text: that.lang["tour-create-business-upload-logo-save"],
          attachTo: {
            element: ".vicp-operate-btn",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      if (!tour.getById("name")) {
        tour.addStep({
          id: "name",
          text: that.lang["tour-create-business-name"],
          attachTo: {
            element: ".name",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action() {
                return this.show("upload-logo");
              },
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      // if (!tour.getById("type")) {
      //   tour.addStep({
      //     id: "type",
      //     text: that.lang["tour-create-business-type"],
      //     attachTo: {
      //       element: ".type",
      //       on: "top",
      //     },
      //     buttons: [
      //       {
      //         text: that.lang["tour-previous-step"],
      //         action: tour.back,
      //         classes: "shepferd-theme-prev-btn",
      //       },
      //     ],
      //   });
      // }
      if (!tour.getById("category")) {
        tour.addStep({
          id: "category",
          text: "Choose a category of your business",
          attachTo: {
            element: ".category",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      if (!tour.getById("subcategory")) {
        tour.addStep({
          id: "subcategory",
          text: "Choose a subcategory of your business",
          attachTo: {
            element: ".subcategory",
            on: "top",
          },
          // showOn: function() {
          //   return this.subcategories && this.subcategories.length
          // },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      if (!tour.getById("description")) {
        tour.addStep({
          id: "description",
          text: that.lang["tour-create-business-description"],
          attachTo: {
            element: ".description",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("email")) {
        tour.addStep({
          id: "email",
          text: that.lang["tour-create-business-email"],
          attachTo: {
            element: ".email",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      if (!tour.getById("phone")) {
        tour.addStep({
          id: "phone",
          text: that.lang["tour-create-business-phone"],
          attachTo: {
            element: ".phone",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }
      if (!tour.getById("neighbourhood")) {
        tour.addStep({
          id: "neighbourhood",
          text: that.lang["tour-create-business-neighbourhood"],
          attachTo: {
            element: ".neighbourhood",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("municipality")) {
        tour.addStep({
          id: "municipality",
          text: "Municipality field",
          attachTo: {
            element: ".municipality",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("website")) {
        tour.addStep({
          id: "website",
          text: that.lang["tour-create-business-website"],
          attachTo: {
            element: ".website",
            on: "bottom",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("internetAccess")) {
        tour.addStep({
          id: "internetAccess",
          text: that.lang["tour-create-business-internet"],
          attachTo: {
            element: ".internetAccess",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("cashiersDevice")) {
        tour.addStep({
          id: "cashiersDevice",
          text: that.lang["tour-create-business-device"],
          attachTo: {
            element: ".cashiersDevice",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("employees")) {
        tour.addStep({
          id: "employees",
          text: that.lang["tour-create-business-employees"],
          attachTo: {
            element: ".employees",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("status")) {
        tour.addStep({
          id: "status",
          text: that.lang["tour-create-business-status"],
          attachTo: {
            element: ".status",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("chambers")) {
        tour.addStep({
          id: "chambers",
          text: that.lang["tour-create-business-canaco"],
          attachTo: {
            element: ".chambers",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("ref")) {
        tour.addStep({
          id: "ref",
          text: that.lang["tour-create-business-referral"],
          attachTo: {
            element: ".ref",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
            {
              text: that.lang["tour-next-step"],
              action: tour.next,
              classes: "shepferd-theme-next-btn",
            },
          ],
        });
      }
      if (!tour.getById("next")) {
        tour.addStep({
          id: "next",
          text: that.lang["tour-create-business-next"],
          attachTo: {
            element: ".next",
            on: "top",
          },
          buttons: [
            {
              text: that.lang["tour-previous-step"],
              action: tour.back,
              classes: "shepferd-theme-prev-btn",
            },
          ],
        });
      }

      tour.start();

      if (tour.isActive() && localStorage.tutorialStep != "") {
        tour.hide();
        if (localStorage.tutorialStep == "add") {
          tour.show("upload-logo");
        } else {
          tour.show(localStorage.tutorialStep);
        }
      }
    },
    getBusinessEdit() {
      if (!this.socials) {
        this.$set(this.business, "phoneNumber", this.editBusiness.phone_number);
        this.$set(this.business, "name", this.editBusiness.shop_name);
        this.$set(this.business, "type", 0);
        this.$set(
          this.business,
          "description",
          this.editBusiness.shop_description
        );
        this.$set(this.business, "email", this.editBusiness.shop_email);
        this.$set(this.business, "phoneCode", this.editBusiness.phone_code);
        this.$set(this.business, "phoneExt", this.editBusiness.ext);
        this.$set(
          this.business,
          "neighbourhood",
          this.editBusiness.neighbourhood
        );
        this.$set(this.business, "website", this.editBusiness.shop_website);
        this.$set(this.business, "chambers", this.editBusiness.canaco_id);
        this.$set(this.business, "chambers", this.editBusiness.canaco_id);
        this.$set(this.business, "internetAccess", this.editBusiness.internet);
        this.$set(this.business, "status", this.editBusiness.status);
        this.$set(
          this.business,
          "municipality",
          this.editBusiness.municipality
        );

        this.imgDataUrl = this.editBusiness.shop_logo;
        this.oldImgUrl = this.editBusiness.shop_logo;
        let categoriesKey = 0;
        for (var key in this.editBusiness.categories) {
          categoriesKey = key;
          this.$set(
            this.business,
            "category",
            this.editBusiness.categories[key].id
          );
        }
        let subcategories = [];
        if (this.editBusiness.categories[categoriesKey].subcategory) {
          for (
            let i = 0;
            i < this.editBusiness.categories[categoriesKey].subcategory.length;
            i++
          ) {
            subcategories.push(
              this.editBusiness.categories[categoriesKey].subcategory[i].id
            );
          }
        }
        this.$set(this.business, "subcategories", subcategories);
      } else {
        this.$set(this.business, "phoneNumber", this.editBusiness.phone_number);
        this.$set(this.business, "name", this.editBusiness.name);
        this.$set(this.business, "type", this.editBusiness.type);
        this.$set(this.business, "description", this.editBusiness.description);
        this.$set(this.business, "email", this.editBusiness.email);
        this.$set(this.business, "phoneCode", this.editBusiness.phone_code);
        this.$set(this.business, "phoneExt", this.editBusiness.ext);
        this.$set(this.business, "label", this.editBusiness.is_public);
        this.$set(
          this.business,
          "neighbourhood",
          this.editBusiness.neighbourhood
        );
        this.$set(this.business, "website", this.editBusiness.website);
        this.$set(this.business, "internetAccess", this.editBusiness.internet);
        this.$set(this.business, "status", this.editBusiness.status);
        this.$set(this.business, "cashiersDevice", 44);
        this.$set(this.business, "category", 44);
        this.$set(this.business, "subcategories", ["1", "2"]);

        this.imgDataUrl = this.editBusiness.logo;
        this.oldImgUrl = this.editBusiness.logo;
      }
    },
  },
  computed: {
    ...mapGetters(["loggedUser"]),
    validateInfo() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    nameError() {
      const errors = [];
      if (!this.$v.business.name.$dirty) {
        return errors;
      }
      !this.$v.business.name.required && this.socials
        ? errors.push("validation_social_name_required")
        : !this.$v.business.name.required
        ? errors.push("validation_business_name_required")
        : errors.push();
      return errors;
    },
    typeError() {
      const errors = [];
      if (!this.$v.business.type.$dirty) {
        return errors;
      }
      !this.$v.business.type.required && this.socials
        ? errors.push("validation_social_type_required")
        : !this.$v.business.type.required
        ? errors.push("validation_business_type_required")
        : errors.push();
      return errors;
    },
    categoryError() {
      const errors = [];
      if (!this.$v.business.category.$dirty) {
        return errors;
      }
      !this.$v.business.category.required &&
        errors.push("validation_business_category_required");
      return errors;
    },
    /*subcategoryError() {
      const errors = [];
      if (!this.$v.business.subcategories.$dirty) {
        return errors;
      }
      !this.$v.business.subcategories.required &&
        errors.push("validation_business_subcategory_required");
      return errors;
    },*/
    emailError() {
      const errors = [];
      if (!this.$v.business.email.$dirty) {
        return errors;
      }
      !this.$v.business.email.required &&
        errors.push("validation_email_required");
      if (!this.$v.business.email.email) {
        errors.push("validation_email_incorrect");
        return errors;
      }
      return errors;
    },
    municipalityError() {
      const errors = [];
      if (!this.$v.business.municipality.$dirty) {
        return errors;
      }
      !this.$v.business.municipality.required &&
        errors.push("Municipality is required");
      return errors;
    },
    statusError() {
      const errors = [];
      if (!this.$v.business.status.$dirty || this.socials) {
        return errors;
      }
      !this.$v.business.status.required &&
        errors.push("Status field is required");
      return errors;
    },
    phoneNumberError() {
      const errors = [];
      console.log(this.business.phoneNumber);
      if (!this.$v.business.phoneNumber.$dirty) {
        return errors;
      } else if (!this.$v.business.phoneNumber.required) {
        errors.push("validation_phone_number_required");
        return errors;
      }
      if (
        !this.$v.business.phoneNumber.minLength ||
        !this.$v.business.phoneNumber.maxLength
      ) {
        errors.push("validation_phone_number_incorrect");
      }
      return errors;
    },
    phoneCodeError() {
      const errors = [];
      if (!this.$v.business.phoneCode.$dirty) {
        return errors;
      } else if (!this.$v.business.phoneCode.required) {
        errors.push("validation_phone_code_required");
        return errors;
      }
      if (!this.$v.business.phoneCode.maxLength) {
        errors.push("validation_phone_code_required");
      }
      if (!this.$v.business.phoneCode.minLength) {
        errors.push("validation_phone_code_required");
      }
      return errors;
    },
  },
};
</script>

<style scoped>
.col {
  padding: 0 !important;
}
.img-btn {
  border-radius: 20px;
  width: 175px !important;
  height: 175px !important;
  color: #72afe7;
  border: 1px solid #72afe7 !important;
  padding: 20px;
  text-transform: none;
  display: block;
}
.ins-img {
  border-radius: 20px;
  width: 175px;
  height: 175px;
  top: -120px !important;
  color: #72afe7;
  border: 1px solid #72afe7 !important;
  text-transform: none;
}

.req {
  color: red;
}
</style>